module.exports = __webpack_public_path__ + "static/media/galerija_2019 (32).8031d7cf.jpg";